export namespace AppRoutes {
    export namespace Signin {
        export enum Route {
            ROOT = 'signin'
        }

        export enum Childrend {
            ACTIVATE = 'activate',
            RESET_PASSWORD = 'reset'
        }
    }

    export namespace Profile {
    }

    export enum Signin {
        SIGNIN = 'signin',
        ACTIVATE = 'signin/activate',
        RESET_PASSWORD = 'signin/reset'
    }

    export enum Profile {
        PROFILE = 'profile'
    }
}